<template>
  <div>
    <Header />
    <Scroll />
    <div class="mall_mypageWrap">
      <div class="mall_flexWrap">
        <!-- 왼쪽 메뉴 -->
        <div class="mallMy_LeftWrap">
          <ul class="mallMy_TermList">
            <li :class="{ active: statusData.section === '1' }">
              <router-link :to="{ query: { section: '1' } }">이용안내</router-link>
            </li>
            <li :class="{ active: statusData.section === '2' }">
              <router-link :to="{ query: { section: '2' } }">이용약관</router-link>
            </li>
            <li :class="{ active: statusData.section === '3' }">
              <router-link :to="{ query: { section: '3' } }">개인정보취급방침</router-link>
            </li>
          </ul>
        </div>

        <!-- 오른쪽 콘텐츠 -->
        <div class="mallMy_RightWrap">
          <div class="mallMy_Right_termBox">
            <h2>{{ statusData.title }}</h2>
            <div v-html="statusData.content"></div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import {
  section1, section2, section3
} from '../TermsAndPolicies/TermsAndPolicies.vue'

export default {
  name: 'Info',
  components: {
    Header,
    Footer,
    Scroll
  },
  data () {
    return {
      statusData: {
        section: this.$route.query.section || '1',
        title: this.getSectionTitle(this.$route.query.section || '1'),
        content: this.getSectionContent(this.$route.query.section || '1')
      }
    }
  },
  methods: {
    getSectionTitle (section) {
      if (section === '1') return '이용안내'
      if (section === '2') return '이용약관'
      if (section === '3') return '개인정보취급방침'
    },
    getSectionContent (section) {
      if (section === '1') return section1()
      if (section === '2') return section2()
      if (section === '3') return section3()
    }
  },
  watch: {
    '$route.query.section': function (newSection) {
      this.statusData.section = newSection || '1'
      this.statusData.title = this.getSectionTitle(newSection || '1')
      this.statusData.content = this.getSectionContent(newSection || '1')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Info/Info.vue